import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=3764c6ce&scoped=true"
import script from "./confirm.vue?vue&type=script&scoped=true&lang=js"
export * from "./confirm.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./confirm.vue?vue&type=style&index=0&id=3764c6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764c6ce",
  null
  
)

export default component.exports